import {RouteNames} from '@/brief-hub/router/route-names';
import {computed} from 'vue';
import {useRoute} from 'vue-router';

export function useStrategyCurrentStep() {
    const steps = [
        {
            number: 1,
            routes: [
                RouteNames.STRATEGY_BRIEF_NEW,
                RouteNames.STRATEGY_BRIEF_FREELANCER_PROFILE,
                RouteNames.STRATEGY_BRIEF_FREELANCER_FUNCTIONAL_SCOPES,
                RouteNames.STRATEGY_BRIEF_FREELANCER_INDUSTRY_EXPERTISES,
                RouteNames.STRATEGY_BRIEF_FREELANCER_SKILLS,
            ],
        },
        {
            number: 2,
            routes: [
                RouteNames.STRATEGY_BRIEF_WHEN_CONDITIONS,
                RouteNames.STRATEGY_BRIEF_WHERE_CONDITIONS,
                RouteNames.STRATEGY_BRIEF_MISSION_DESCRIPTION,
                RouteNames.STRATEGY_BRIEF_OVERVIEW,
            ],
        },
    ];

    const $route = useRoute();

    const currentStepNumber = computed<number>(() => {
        const step = steps.find(({routes}) => routes.find((route) => $route.name === route));

        return step ? step.number : 1;
    });

    const currentSubStepNumber = computed<number>(() => {
        return $route.name ? steps[currentStepNumber.value - 1].routes.indexOf($route.name as string) + 1 : 1;
    });

    return {currentStepNumber, currentSubStepNumber};
}
